import { AppSidebar, AppMobileDrawer } from "@apps/dashboard/components/layout/AppSidebar";
import { AppTopBar } from "@apps/dashboard/components/layout/AppTopBar";
import { AnimatedOutlet } from "@apps/dashboard/components/layout/AnimatedOutlet";
import { useAcceptPendingHouseInviteOnShellMount } from "@apps/dashboard/features/houses/use-accept-pending-house-invite";

/**
 * Shell principal: sidebar + top bar + contenido.
 * `ActiveHouseProvider` envuelve rutas protegidas en `App.tsx` (incluye onboarding).
 */
function AppShellInner(): JSX.Element {
  useAcceptPendingHouseInviteOnShellMount();
  return (
    <>
      <AppSidebar />
      <AppMobileDrawer />
      <div className="flex min-h-screen flex-col lg:ml-64">
        <AppTopBar />
        <div className="relative z-0 flex-1">
          <AnimatedOutlet />
        </div>
      </div>
    </>
  );
}

export function AppShell(): JSX.Element {
  return (
    <div className="min-h-screen bg-surface font-body text-on-surface">
      <AppShellInner />
    </div>
  );
}
